(() => {
  const root = document.querySelector('[data-odd-studio]');
  if (!root) return;
  const form = root.querySelector('form');
  const canvas = root.querySelector('canvas');
  const ctx = canvas.getContext('2d');
  const status = root.querySelector('[role="status"]');
  const generate = root.querySelector('[data-generate]');
  const add = root.querySelector('[data-add]');
  let design = null, artwork = null, generating = false;
  const fields = () => Object.fromEntries(new FormData(form));
  const draw = () => {
    const f = fields();
    const type = form.elements.variant.selectedOptions[0]?.dataset.type || 'tee';
    ctx.clearRect(0, 0, 900, 1000);
    ctx.fillStyle = '#e9e9dc'; ctx.fillRect(0, 0, 900, 1000);
    ctx.save(); ctx.translate(450, 470);
    ctx.fillStyle = '#292b28'; ctx.strokeStyle = '#121410'; ctx.lineWidth = 4;
    ctx.beginPath();
    if (type === 'mug') {
      ctx.strokeStyle = '#292b28'; ctx.lineWidth = 42;
      ctx.ellipse(225, -15, 112, 140, 0, 0, Math.PI * 2); ctx.stroke();
      ctx.beginPath(); ctx.strokeStyle = '#121410'; ctx.lineWidth = 4;
      ctx.roundRect(-225, -230, 420, 430, 30);
    } else if (type === 'tote') {
      ctx.strokeStyle = '#292b28'; ctx.lineWidth = 20;
      ctx.moveTo(-120, -240); ctx.bezierCurveTo(-140, -500, 140, -500, 120, -240);
      ctx.stroke(); ctx.beginPath(); ctx.strokeStyle = '#121410'; ctx.lineWidth = 4;
      ctx.roundRect(-245, -240, 490, 540, 15);
    } else {
      ctx.moveTo(-135, -300);ctx.lineTo(-270, -270);ctx.lineTo(-370, -120);ctx.lineTo(-265, -50);ctx.lineTo(-215, -115);ctx.lineTo(-225, 370);ctx.lineTo(225, 370);ctx.lineTo(215, -115);ctx.lineTo(265, -50);ctx.lineTo(370, -120);ctx.lineTo(270, -270);ctx.lineTo(135, -300);ctx.bezierCurveTo(115, -185, -115, -185, -135, -300);
    }
    ctx.closePath();ctx.fill();ctx.stroke();
    if (artwork) ctx.drawImage(artwork, -145, -155, 290, 290);
    ctx.fillStyle = f.ink; ctx.textAlign = 'center';ctx.textBaseline = 'middle';
    const font = f.style === 'retro' ? 'Georgia' : f.style === 'minimal' ? 'Courier New' : 'Arial';
    ctx.font = `900 ${f.style === 'minimal' ? 28 : 38}px "${font}"`;
    const words = f.slogan.trim().split(/\s+/);const lines=[];let line='';
    for(const word of words){const next=line?`${line} ${word}`:word;if(ctx.measureText(next).width>320&&line){lines.push(line);line=word;}else line=next;}if(line)lines.push(line);
    lines.forEach((text,i)=>{ctx.fillText(text,0,(artwork?170:-60)+i*45,340);});
    if(f.style==='retro'){ctx.strokeStyle=f.ink;ctx.lineWidth=2;ctx.strokeRect(-185,artwork?138:-105,370,lines.length*45+45);}
    ctx.restore();ctx.fillStyle='#626758';ctx.font='19px Arial';ctx.textAlign='center';ctx.fillText('ILLUSTRATIVE PREVIEW · FINAL PRINT REVIEW REQUIRED',450,950);
  };
  const update = (event) => {
    if(event?.target?.name==='prompt'||event?.target?.name==='style'){design=null;artwork=null;}
    add.disabled = root.dataset.ordersEnabled !== 'true' || !form.elements.variant.value || generating;
    draw();
  };
  form.addEventListener('input',update);
  generate.addEventListener('click',async()=>{
    if(root.dataset.aiEnabled!=='true'||generating)return;
    const f=fields();if(!f.prompt.trim()){status.textContent='Describe your illustration first.';return;}
    if(!f.rights){status.textContent='Confirm you have the rights to your design first.';return;}
    generating=true;generate.disabled=true;add.disabled=true;status.textContent='Creating your artwork. This can take a minute or two…';
    try{
      const response=await fetch(`${root.dataset.endpoint}/generate`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({prompt:f.prompt,style:f.style}),signal:AbortSignal.timeout(180000)});
      let result=await response.json();if(!response.ok)throw new Error(result.error||'Generation is unavailable. Please try again later.');
      if(!/^[0-9a-f-]{36}$/.test(result.jobId||''))throw new Error('The design service returned an invalid job.');
      const jobId=result.jobId;
      for(let attempt=0;attempt<75;attempt++){
        await new Promise(resolve=>setTimeout(resolve,2500));
        const poll=await fetch(`${root.dataset.endpoint}/jobs/${jobId}`,{signal:AbortSignal.timeout(15000)});result=await poll.json();
        if(!poll.ok||result.status==='failed')throw new Error(result.error||'Generation could not be completed.');
        if(result.status==='complete')break;
      }
      if(result.status!=='complete')throw new Error('Generation is taking longer than expected. Please try again later.');
      if(!/^https:\/\//.test(result.imageUrl)||!result.designId)throw new Error('The design service returned an invalid preview.');
      const image=new Image();image.src=result.imageUrl;await image.decode();
      // Do not apply a result to a prompt edited while generation was in progress.
      if(fields().prompt!==f.prompt||fields().style!==f.style){status.textContent='Your prompt changed. Generate again to use the updated idea.';return;}
      design=result;artwork=image;draw();status.textContent='Artwork ready. Review your design before adding it.';
    }catch(error){status.textContent=error.name==='TimeoutError'?'Generation timed out. Please try again later.':error.message;}
    finally{generating=false;generate.disabled=false;update();}
  });
  form.addEventListener('submit',async(event)=>{
    event.preventDefault();if(root.dataset.ordersEnabled!=='true'||!form.reportValidity()||generating)return;const f=fields();if(!f.variant)return;
    if(f.prompt.trim()&&!design){status.textContent='Generate your artwork first, or clear the illustration prompt to order text only.';return;}
    add.disabled=true;status.textContent='Adding your personalized product…';
    try{
      const properties={'Custom text':f.slogan,'Design style':f.style,'Ink color':f.ink,'Print review':'Required'};
      if(design){properties['Design reference']=design.designId;properties['Artwork preview']=design.imageUrl;}
      const base=window.Shopify?.routes?.root||'/';
      const response=await fetch(`${base}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:Number(f.variant),quantity:1,properties}]})});
      const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add this variant. Please try again.');
      window.location.assign(`${base}cart`);
    }catch(error){status.textContent=error.message;add.disabled=false;}
  });
  update();
})();
